import PropTypes from "prop-types"

export const isBlankAnswer = answer => !String(answer?.answer ?? "").trim()

export const DeleteBlankAnswerButton = ({ onDelete }) => (
  <button
    type="button"
    className="btn btn-link text-danger text-nowrap px-2"
    onClick={onDelete}
  >
    Eliminar
  </button>
)

DeleteBlankAnswerButton.propTypes = {
  onDelete: PropTypes.func,
}
